import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';

import { AuthActionTypes } from '../actions/auth.actions';
import { UserActionTypes } from '../actions';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { MSALAuthService } from '@app/auth/msal-auth.service';

/**
 * AuthEpics
 */
@Injectable()
export class AuthEffects {
  /**
   * constructor
   * @param {AuthService} authService
   */
  constructor(private authService: MSALAuthService, private actions$: Actions) {}

  /**
   * login
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  login = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGIN_SUCCESS),
      map(() => ({ type: UserActionTypes.LOAD_USER })),
    ),
  );

  /**
   * logout
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  logout = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGOUT),
      tap(() => this.authService.logout()),
      map(() => ({ type: 'UPDATE_LOCATION', payload: '' })),
    ),
  );
}
